/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { ButtonGroup, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Button, DropDown, Input } from "../../components";
import { useAppSelector } from "../../redux/Hooks/Hook";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { CourtDetailType, ratesType } from "../../utilities/types";
import { SubmitHandler, useForm } from "react-hook-form";
import { images } from "../../config/images";
import { DeleteCourtRate } from "../../utilities/api/courts";
import { toast } from "react-toastify";
import { messages } from "../../utilities/Messages";

const getMessage = messages.courts
const courtSchema = yup.object().shape({
  name: yup
    .string()
    .required(getMessage.name_isNotEmpty)
    .min(2, getMessage.name_minLength)
    .max(10, getMessage.name_maxLength)
    .matches(
      /^[a-zA-Z0-9\s\-.@(),/&#]*$/,
      getMessage.name_matches
    ),
  sportId: yup
    .number()
    .typeError(getMessage.sport_name)
    .required(getMessage.sport_nameIsNotEmpty),
  preBookingMaxDays: yup
    .number()
    .typeError(getMessage.preBookingMaxDays_isNotEmpty)
    .max(365, getMessage.preBookingMaxDays_max)
    .required(getMessage.preBookingMaxDays_isNotEmpty),

  openTime: yup.string().required(getMessage.openTime_isNotEmpty),
  closeTime: yup.string().required(getMessage.closeTime_isNotEmpty),
});

const AddUpdateCourts = (props: any) => {
  const { courtData, name, handleCreateUpdate, id, submitButton } = props;
  let initialState = {
    rateId: "",
    ratePerSlot: "",
    startTime: "",
    endTime: "",
  };
  const [rateObj, SetRateObj] = useState<ratesType>(initialState);
  const [rate, setRate] = useState<any>(courtData.rates ? courtData.rates : []);

  const [errorMessage, setErrorMessage] = useState({
    rate: "",
    ratePerSlot: "",
    startTime: "",
    endTime: "",
  });
  const navigate = useNavigate();
  const { AllSportsData, sportErrorMessage } = useAppSelector((state) => state.sportList);
  const { SelectedFacility } = useAppSelector((state) => state.facilityList);
  const {
    formState: { errors },
    handleSubmit,
    register,
    reset,
  } = useForm<CourtDetailType>({
    resolver: yupResolver(courtSchema),
  });
  const [openTime, setOpenTime] = useState(courtData?.openTime);
  const [closeTime, setCloseTime] = useState(courtData?.closeTime);
  const [slotStartTime, setSlotStartTime] = useState("");
  const [closeTimeDropdown, setCloseTimeDropdown] = useState<string[]>([]);
  const [slotStartTimeOptions, setSlotStartTimeOptions] = useState<string[]>(
    []
  );
  const [slotEndTimeOptions, setSlotEndTimeOptions] = useState<string[]>([]);
  if (sportErrorMessage) {
    toast.error(sportErrorMessage.message)
  }
  const hours = Array.from({ length: 24 }, (_, i) =>
    i.toString().padStart(2, "0")
  );
  const minutes = ["00", "30"];
  const TimeArray = hours.flatMap((hour) =>
    minutes.map((minute) => `${hour}:${minute}`)
  );

  const handleCancel = () => {
    navigate("/courts");
  };

  const validateGst = () => {
    if (rate.length <= 0) {
      setErrorMessage({
        rate: getMessage.rates_size,
        ratePerSlot: !rateObj.ratePerSlot ? getMessage.ratePerSlot_isNotEmpty : "",
        startTime: !rateObj.startTime ? getMessage.startTime_isNotEmpty : "",
        endTime: !rateObj.endTime ? getMessage.endTime_isNotEmpty : "",
      });
      return false;
    } else {
      setErrorMessage({ rate: "", ratePerSlot: "", startTime: "", endTime: "" });
      return true;
    }
  };

  const onSubmit: SubmitHandler<CourtDetailType> = (data) => {
    data.isActive = `${data.isActive}`;
    delete data.startTime;
    delete data.endTime;
    validateGst() &&
      handleCreateUpdate({
        ...courtData,
        ...data,
        rates: rate,
      });
  };

  useEffect(() => {
    reset(courtData);
  }, [courtData]);

  const handleAddRates = () => {
    let ratePerSlot = Number(rateObj.ratePerSlot);
    if (rate.length === 0) {
      setRate([...rate, { ...rateObj, ratePerSlot: ratePerSlot }]);
      courtData.rates = [...rate, { ...rateObj, ratePerSlot: ratePerSlot }];
      setErrorMessage({ rate: "", ratePerSlot: "", startTime: "", endTime: "" });
    } else {
      rate?.forEach((item: any) => {
        if (
          item.startTime !== rateObj.startTime &&
          item.endTime !== rateObj.endTime &&
          rateObj.startTime !== rateObj.endTime
        ) {
          setRate([...rate, { ...rateObj, ratePerSlot: ratePerSlot }]);
          courtData.rates = [...rate, { ...rateObj, ratePerSlot: ratePerSlot }];
          setErrorMessage({ rate: "", ratePerSlot: "", startTime: "", endTime: "" });
        } else {
          setErrorMessage({ rate: getMessage.slotDuration_isNotEmpty, ratePerSlot: "", startTime: "", endTime: "" });
        }
      });
    }
    const filteredOptions1 = slotStartTimeOptions.filter(
      (option) => option < rateObj.startTime
    );
    const filteredOptions2 = slotStartTimeOptions.filter(
      (option) => option >= rateObj.endTime
    );
    setSlotStartTimeOptions([...filteredOptions1, ...filteredOptions2]);
    SetRateObj(initialState);
  };

  const handleRateDelete = async (item: any, index: number) => {
    const filtResult = rate.filter(
      (elem: ratesType, ind: number) => ind !== index
    );
    name !== "Edit Court" && setRate(filtResult);
    const filteredOptions = TimeArray.filter(
      (option) => option >= item.startTime && option <= item.endTime
    );
    const temp = [...slotStartTimeOptions, ...filteredOptions].sort();
    const temp2 = temp.filter((ite, ind) => temp.indexOf(ite) === ind);
    setSlotStartTimeOptions(temp2);
    let rateid = rate.filter((elem: ratesType, ind: number) => ind === index)[0]
      .rateId;
    if (name === "Edit Court" && rateid && courtData.rates.length > 0) {
      const result = await DeleteCourtRate(id, rateid);
      if (result.status === 200) {
        setRate(filtResult);
        courtData.rates = filtResult;
        toast.success(result.data.message);
      } else toast.error(result.response.data.message);
    } else {
      setRate(filtResult);
    }
  };

  useEffect(() => {
    if (openTime && closeTime) {
      const filteredOptions = TimeArray.filter(
        (item) => item >= openTime && item <= closeTime
      );
      setSlotStartTimeOptions(filteredOptions);
    }
    if (openTime) {
      const filteredOptions = TimeArray.filter((item) => item > openTime);
      setCloseTimeDropdown(filteredOptions);
    }
  }, [openTime, closeTime]);

  useEffect(() => {
    if (name !== "Edit Court" && SelectedFacility === "") {
      toast.error(getMessage.error_select);
    }
  }, [SelectedFacility]);

  const handleOpenTimeChange = (e: any) => {
    const selectedTime = e.target.value;
    setOpenTime(selectedTime);

  };

  const handleCloseTimeChange = (e: any) => {
    const selectedTime = e.target.value;
    setCloseTime(selectedTime);

  };

  const handleSlotStartTimeChange = (e: any) => {
    const selectedTime = e.target.value;
    SetRateObj({ ...rateObj, startTime: selectedTime });
    setSlotStartTime(selectedTime);
    const filteredOptions = slotStartTimeOptions.filter(
      (option) => option > selectedTime && option <= closeTime
    );
    const startArray = rate.map((item: any) =>
      item.startTime >= selectedTime ? item.startTime : ""
    );
    const endArray = rate.map((elem: any) => elem.endTime);
    const temp = filteredOptions
      .filter((item) => !endArray.includes(item))
      .concat(startArray)
      .sort();
    setSlotEndTimeOptions(temp);
  };

  const handleSlotEndTimeChange = (e: any) => {
    const selectedTime = e.target.value;
    SetRateObj({ ...rateObj, endTime: selectedTime });
  };

  return (
    <Container fluid className="g-0">
      <Card>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Card.Body>
            <Card.Title className="text-start">{name}</Card.Title>
            <Row>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="sports" className="form-label">
                    Sports <small className="text-danger">*</small>
                  </label>
                  <DropDown
                    disabled={SelectedFacility === "" || name === "Edit Court"}
                    name="sportId"
                    id="sports"
                    className="form-control"
                    defaultValue={courtData?.sportId}
                    register={register}
                    required
                  >
                    <option hidden disabled value="">
                      Select Sports
                    </option>
                    {AllSportsData?.map((item: any) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </DropDown>
                  <span className="error-msg">{errors?.sportId?.message}</span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="courtname" className="form-label">
                    Court Name <small className="text-danger">*</small>
                  </label>
                  <Input
                    defaultValue={courtData?.name}
                    register={register}
                    required
                    type="text"
                    placeholder="Enter Courts Name"
                    id="courtname"
                    name="name"
                    className="form-control"
                  />
                  <span className="error-msg">{errors?.name?.message}</span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="maxprebookingdays" className="form-label">
                    Max Pre Booking Days <small className="text-danger">*</small>
                  </label>
                  <Input
                    defaultValue={courtData?.preBookingMaxDays}
                    register={register}
                    required
                    type="number"
                    min="1"
                    placeholder="Enter Days"
                    id="preBookingMaxDays"
                    name="preBookingMaxDays"
                    className="form-control"
                    onKeyDown={(e: any) =>
                      ["e", ".", "-", "+"].includes(e.key) && e.preventDefault()
                    }
                    onWheel={(e: any) => e.target.blur()}
                  />
                  <span className="error-msg">{errors?.preBookingMaxDays?.message}</span>
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="courtopentime" className="form-label">
                    Court Open Time <small className="text-danger">*</small>
                  </label>
                  <DropDown
                    id="opningTime"
                    name="openTime"
                    className="form-control"
                    defaultValue={courtData?.openTime}
                    register={register}
                    required
                    onChange={handleOpenTimeChange}
                  >
                    <option hidden disabled value="">
                      Select Open Time
                    </option>
                    {TimeArray.map(item => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </DropDown>
                  <span className="error-msg">{errors?.openTime?.message}</span>
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3 text-start">
                  <label htmlFor="courtclosetime" className="form-label">
                    Court Close Time <small className="text-danger">*</small>
                  </label>
                  <DropDown
                    disabled={!openTime}
                    id="closingTime"
                    name="closeTime"
                    className="form-control"
                    defaultValue={courtData?.closeTime}
                    register={register}
                    required
                    onChange={handleCloseTimeChange}
                  >
                    <option hidden disabled value="">
                      Select Close Time
                    </option>
                    {closeTimeDropdown.map((option: any) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </DropDown>
                  <span className="error-msg">{errors?.closeTime?.message}</span>
                </div>
              </Col>
            </Row>
            <Row className="align-items-start">
              <Col lg={3}>
                <div className="mb-3 text-start">
                  <label htmlFor="rateperslot" className="form-label">
                    Rate per Slot <small className="text-danger">*</small>
                  </label>
                  <Input
                    value={rateObj.ratePerSlot}
                    type="number"
                    onChange={(e: any) => {
                      if (/^([0-9]{0,10}|\d)(\.\d{1,2})?$/.test(e.target.value)) {
                        SetRateObj({ ...rateObj, ratePerSlot: e.target.value });
                        setErrorMessage((prev) => ({ ...prev, ratePerSlot: "" }));
                      }
                    }}
                    placeholder="Enter Rate"
                    id="rateperslot"
                    name="ratePerSlot"
                    min="1"
                    className="form-control"
                    onKeyDown={(e: any) => ["e", "-", "+"].includes(e.key) && e.preventDefault()}
                    onWheel={(e: any) => e.target.blur()}
                  />
                  <span className="error-msg">{errorMessage.ratePerSlot || errorMessage.rate}</span>
                </div>
              </Col>
              <Col lg={3}>
                <div className="mb-3 text-start">
                  <label htmlFor="start-time" className="form-label">
                    Start Time <small className="text-danger">*</small>
                  </label>
                  <DropDown
                    disabled={!openTime || !closeTime}
                    id="start-time"
                    name="startTime"
                    className="form-control"
                    register={register}
                    required
                    value={rateObj.startTime}
                    onChange={(e: any) => {
                      handleSlotStartTimeChange(e);
                      setErrorMessage((prev) => ({ ...prev, startTime: "" }));
                    }}
                  >
                    <option hidden disabled value="">
                      Select Start Time
                    </option>
                    {slotStartTimeOptions.map((option, ind) => (
                      <option key={option + ind} value={option}>
                        {option}
                      </option>
                    ))}
                  </DropDown>
                  <span className="error-msg">{errorMessage.startTime}</span>
                </div>
              </Col>
              <Col lg={3}>
                <div className="mb-3 text-start">
                  <label htmlFor="end-time" className="form-label">
                    End Time <small className="text-danger">*</small>
                  </label>
                  <DropDown
                    disabled={!openTime || !closeTime || !slotStartTime}
                    id="end-time"
                    name="endTime"
                    className="form-control"
                    register={register}
                    required
                    value={rateObj.endTime}
                    onChange={(e: any) => {
                      handleSlotEndTimeChange(e);
                      setErrorMessage((prev) => ({ ...prev, endTime: "" }));
                    }}
                  >
                    <option hidden disabled value="">
                      Select End Time
                    </option>
                    {slotEndTimeOptions.map((options, index) => (
                      <option key={options + index} value={options}>
                        {options}
                      </option>
                    ))}
                  </DropDown>
                  <span className="error-msg">{errorMessage.endTime}</span>
                </div>
              </Col>
              <Col lg={3}>
                <div className="mb-3 text-start" style={{ marginTop: "1.75rem" }}>
                  <Button
                    disabled={
                      Number(rateObj.ratePerSlot) < 100 ||
                      rateObj.startTime.length < 4 ||
                      rateObj.endTime.length < 4
                    }
                    onClick={handleAddRates}
                    type="button"
                    bname="Add"
                    name="Add"
                    id="Add"
                    className="btn btn-primary rounded-1"
                  ></Button>
                </div>
              </Col>
            </Row>
            <Row className="text-start">
              <Col lg={12}>
                {rate?.map((item: ratesType, index: number) => {
                  return (
                    <div
                      key={index}
                      className="bg-light d-inline-block p-2 rounded-1 slot-box text-start mb-2 me-4"
                      style={{ maxWidth: "190px" }}
                    >
                      <span className="d-block">
                        {item.startTime} to {item.endTime}
                      </span>
                      <span className="text-primary">
                        <span className="rupees-symbol">&#8377;</span> {item.ratePerSlot}
                      </span>
                      {rate.length > 0 && (
                        <img
                          onClick={() => handleRateDelete(item, index)}
                          src={images.deletesport.default}
                          alt="delete-icon"
                          width="19"
                        />
                      )}
                    </div>
                  );
                })}
              </Col>
              {name === "Edit Court" && (
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="facilityname" className="form-label">
                      Status <small className="text-danger">*</small>
                    </label>
                    <DropDown
                      defaultValue={`${courtData?.isActive}`}
                      register={register}
                      required
                      name="isActive"
                      id="isActive"
                      className="form-control"
                    >
                      <option hidden disabled value={""}>
                        Select Facility Status
                      </option>
                      <option value="true">Active</option>
                      <option value="false">Inactive</option>
                    </DropDown>
                    {errors.isActive && <span>{errors.isActive.message}</span>}
                  </div>
                </Col>
              )}
            </Row>
            <hr />
            <Row>
              <Col className="text-end">
                <ButtonGroup>
                  <Button
                    onClick={handleCancel}
                    type="button"
                    bname="Cancel"
                    name="cancel"
                    id="cancel"
                    className="btn btn-light rounded-1 me-3"
                  ></Button>
                  <Button
                    type="submit"
                    bname={
                      name === "Edit Court"
                        ? submitButton
                          ? "Updating"
                          : "Update"
                        : submitButton
                          ? "Submitting"
                          : "Submit"
                    }
                    name={name === "Edit Court" ? "update" : "submit"}
                    id={name === "Edit Court" ? "update" : "submit"}
                    className="btn btn-primary rounded-1"
                    disabled={submitButton}
                  ></Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Card.Body>
        </form>
      </Card>
    </Container>
  );
};
export { AddUpdateCourts };
